const CopyToClipboard = (elementId) => {
    var targetElement = document.getElementById(elementId);
    document.getElementById("disCode").classList.add("show");
    if (targetElement) {
        var temporaryTextarea = document.createElement("textarea");
        temporaryTextarea.value = targetElement.textContent || targetElement.innerText;
        document.body.appendChild(temporaryTextarea);
        temporaryTextarea.select();
        document.execCommand("copy");
        document.body.removeChild(temporaryTextarea);
    }
};
const copyAlert = () => {};